import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { BannerComponent } from './banner.component';

@NgModule({
  declarations: [BannerComponent],
  imports: [CommonModule, MediaModule, MatIconModule, NgbCarouselModule, I18nModule, RouterModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoRotatingImagesComponent: {
          component: BannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class BannerModule {}
